import {useEffect, useState} from 'react';
import SimpleAccordionContent from './simpleAccordionContent';

export default function SimpleAccordion({
                                          elements = [],
                                          className,
                                          cardClassname,
                                          useMarkdownContent = false,
                                          titleContainerClassName,
                                          contentContainerClassName,
                                          showAll = false,
                                          closedAtBeginning = true,
                                          showIcon = true,
                                        }) {

  // const defaultState = elements.map(_ => !closedAtBeginning);
  // console.log(elements, defaultState);

  const [openedIndex, setOpenedIndex] = useState(
      showAll ?
          elements.map(_ => !closedAtBeginning) :
          closedAtBeginning ? null : 0);

  if (!Array.isArray(elements) || elements.length === 0) return <></>;

  const toggleAccordion = (index, e) => {

    e.preventDefault();

    if (showAll) {

      const _openedIndex = [...openedIndex];

      _openedIndex[index] = !_openedIndex[index];
      setOpenedIndex(_openedIndex);

    } else {

      if (openedIndex === index) {
        setOpenedIndex(null);
      } else {
        setOpenedIndex(index);
      }
    }

  };

  if (!elements || elements.length === 0)
    return <></>;

  return <div className={`${className}`}>
    {
      elements.map((element, index) => {

        const {
          title,
          content,
          useMarkdownContent: useMarkdownContentOnRow = false,
          className: rowContentContainerClassName = '',
        } = element;

        const show = showAll ? openedIndex[index] : openedIndex === index;

        return <div className={cardClassname}
                    key={`ACCORDION_INDEX_${index}`}>

          <div
              className={`cursor-pointer ${titleContainerClassName} flex flex-row items-center justify-between`}
              onClick={(e) => toggleAccordion(index, e)}>
            {title}

            {showIcon && <span> {show ?
                <svg className="w-6 h-6" fill="none" stroke="currentColor"
                     viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round"
                        strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                </svg> :
                <svg className="w-6 h-6" fill="none" stroke="currentColor"
                     viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round"
                        strokeWidth="2" d="M20 12H4"/>
                </svg>} </span>}

          </div>
          {useMarkdownContent || useMarkdownContentOnRow ?
              <div
                  className={`${contentContainerClassName} ${rowContentContainerClassName} accordion-markdown-content ${
                      show ?
                          '' :
                          'hidden'}`}
                  dangerouslySetInnerHTML={{__html: element.content}}/> :
              <div
                  className={`${contentContainerClassName} ${rowContentContainerClassName} ${
                      show ?
                          '' :
                          'hidden'}`}>
                {content}
              </div>}
        </div>;
      })
    }
  </div>;
}